import { Box } from '@chakra-ui/react'
import { DirectionsRenderer, GoogleMap, Marker } from '@react-google-maps/api'
import React from 'react'
import useMapContext from '../hooks/useMapContext';

export const GMap = () => {
    const mapContext = useMapContext();

    return (
        <Box position="absolute" left={0} top={0} h="100%" w="100%">
            {/* Google Map Box */}
            <GoogleMap
                center={mapContext.center}
                zoom={10}
                mapContainerStyle={{ width: "100%", height: "100%" }}
                options={{
                    zoomControl: false,
                    streetViewControl: false,
                    mapTypeControl: false,
                    fullscreenControl: false,
                }}
                onLoad={mapContext.loadMap}
            >
                <Marker position={mapContext.center} />
                {mapContext.directionsResponse && (
                    <DirectionsRenderer directions={mapContext.directionsResponse} />
                )}
                {mapContext.markers?.drivers?.map((location, index) => (
                    <Marker key={index} position={location} icon={location.marker} />
                ))}
                {mapContext.markers?.orders?.map((location, index) => (
                    <Marker key={index} position={location} label={'#' + location.id} icon={location.icon} />
                ))}

            </GoogleMap>
        </Box>
    )
}
